// extracted by mini-css-extract-plugin
module.exports = {"container":"icons-arrow-container","left":"icons-arrow-left"};